import { render, staticRenderFns } from "./UserWalletTransactionFilter.vue?vue&type=template&id=1675a7c3&"
import script from "./UserWalletTransactionFilter.vue?vue&type=script&lang=js&"
export * from "./UserWalletTransactionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports